import { LitEntity, html, css, renderIf } from '../../utility/lit-entity';
import '../../common/bn-loading';
import '../../common/bn-action';
import '../../bins/parts/bin-list-item';
import '../parts/organization-ancestors-bread-crumbs';

class OrganizationDeleteHelper extends LitEntity {
  static get properties() {
    return {
      successtext: { type: String },
    };
  }

  static get styles() {
    return css`
      .cannot-delete {
        text-align: center;
        color: var(--blue-60);
      }
      .bins {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
      }
      .bins a {
        text-decoration: none;
      }
      h4 {
        margin-top: 1.5em;
      }
    `;
  }

  render() {
    if (!this.entity) {
      return html`<bn-loading></bn-loading>`;
    }

    const confirmDelete = this.entity.hasActionByName('confirm-delete');
    const bins = this.entity.getSubEntitiesByClass('bin');
    const orgHref = this.getHref('up');
    const { properties } = this.entity;

    return html`
      ${renderIf(confirmDelete, html`
        <bn-action
          .href="${this.href}"
          actionname="confirm-delete"
          successtext="${this.successtext}"
          buttonstyle='outlinedError'
        >
          <span slot="header">
            <h3>Delete Organization</h3>
            <organization-ancestors-bread-crumbs .href="${orgHref}" linkPath="" ancestorMinIndex="0">
            </organization-ancestors-bread-crumbs>
            <p>This will delete ${properties.usersCount} users, ${properties.descendantsCount} sub-organization and ${properties.binsCount} bins. This action cannot be undone.</p>
          </span>
        </bn-action>
      `)}

      ${renderIf(!confirmDelete, html`
        <p class="cannot-delete">
          This organization cannot currently be deleted as it has bins: in tandem, with devices or with active workorders.<br/>
          Please contact your BinSentry representative to resolve this issue.
        </p>
        ${this._renderBins(bins)}
      `)}
    `;
  }

  _renderBins(bins) {
    if (!bins || bins.length === 0) {
      return html``;
    }

    return html`
      <h4>Bins in tandem, with devices or with active workorders</h4>
      <div class="bins">
        ${bins.map((bin) => html`
          <bin-list-item .href="${bin.href}"></bin-list-item>
        `)}
      </div>
    `;
  }
}

window.customElements.define('organization-delete-helper', OrganizationDeleteHelper);
